import React from "react";
import cryptofolio from "../images/CryptoFolio.png";
import travelbuddy from "../images/TravelBuddy.png";
import lostboy from "../images/lostboy.png";
import oyster from "../images/oyster.png";
import crowdfunding from "../images/home-page.png";

export default function Project() {
  return (
    <div className="container">
      <div className="row my-2">
        <div className="col-md-6 custom-card my-2">
          <a
            href="https://immense-refuge-82677.herokuapp.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="card text-bg-dark">
              <img src={oyster} className="card-img custom-opacity" alt="..." />
              <div class="card-img-overlay">
                <h5 class="card-title">Oyster</h5>
                <p class="card-text">
                  A digital collectible platform with Web3 technology
                </p>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-6 custom-card my-2">
          <a
            href="https://radiant-lowlands-48817.herokuapp.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="card text-bg-dark">
              <img
                src={cryptofolio}
                className="card-img custom-opacity"
                alt="..."
              />
              <div class="card-img-overlay">
                <h5 class="card-title">Cryptofolio</h5>
                <p class="card-text">
                  A cryptocurrency portfolio tracker geared towards beginners
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6 custom-card my-2">
          <a
            href="https://github.com/youssefojeil/Crowdfunding"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="card text-bg-dark">
              <img
                src={crowdfunding}
                className="card-img custom-opacity custom-height"
                alt="..."
              />
              <div class="card-img-overlay">
                <h5 class="card-title mt-4">Crowdfunding dApp</h5>
                <p class="card-text">
                  A crowdfunding dApp built on Ethereum's goerli testnet which
                  allows users to create, donate to and view campaigns
                </p>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-6 custom-card my-2">
          <a
            href="https://joseobm92.github.io/Travel-Buddy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="card text-bg-dark">
              <img
                src={travelbuddy}
                className="card-img custom-opacity custom-height"
                alt="..."
              />
              <div class="card-img-overlay">
                <h5 class="card-title">Travel Buddy</h5>
                <p class="card-text">
                  The perfect Flight and Weather tracking tool built for
                  travelers
                </p>
              </div>
            </div>
          </a>
        </div>
        <div className="col-md-6 custom-card my-2">
          <a
            href="https://www.lostboy.io/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div class="card text-bg-dark">
              <img
                src={lostboy}
                className="card-img custom-opacity custom-height"
                alt="..."
              />
              <div class="card-img-overlay">
                <h5 class="card-title mt-4">LOSTBOY</h5>
                <p class="card-text">
                  A lifestyle brand using web3 technology and music to raise
                  Mental Health Awareness
                </p>
              </div>
            </div>
          </a>
        </div>
      </div>
      <div className="row mt-4">
        <h3>Project Links</h3>
        <div className="col">
          <ul className="list-unstyled m-3">
            <li className="my-4">
              <h4>Oyster</h4>
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/youssefojeil/Oyster"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Repo
                  </a>
                </li>
                <li>
                  <a
                    href="https://immense-refuge-82677.herokuapp.com/"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Deployed Website
                  </a>
                </li>
              </ul>
            </li>
            <li className="my-4">
              <h4>Cryptofolio</h4>
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/youssefojeil/Cryptofolio"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Repo
                  </a>
                </li>
                <li>
                  <a
                    href="https://vast-gorge-15693.herokuapp.com/"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Deployed Website
                  </a>
                </li>
              </ul>
            </li>
            <li className="my-4">
              <h4>Travel Buddy</h4>
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/youssefojeil/Travel-Buddy"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Github Repo
                  </a>
                </li>
                <li>
                  <a
                    href="https://joseobm92.github.io/Travel-Buddy/"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Deployed Website
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <div className="col">
          <ul className="list-unstyled m-3">
            <li>
              <h3>Other</h3>
              <ul>
                <li>
                  {" "}
                  <a
                    href="https://github.com/youssefojeil/NFT-Collection"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    ERC-721 NFT Collection with Minting website
                  </a>
                </li>
                <li>
                  {" "}
                  <a
                    href="https://github.com/youssefojeil/modern-bank-app"
                    className="link-light text-decoration-none"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Modern Bank App
                  </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
